import apiClient from "services/apiClient";

async function addType(data: any) {
  const url = `/admin/types`;
  const res = await apiClient.post(url, data);
  return res.data;
}

export default addType;
